module.exports = __webpack_public_path__ + "img/icon.5fa603b.png";